import { Divider } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setTruInkSelectedSiteOption } from "../../../redux/slices/truInk";
import { useRef } from "react";
import { IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

function TruinkSiteOptions() {
  const dispatch = useDispatch();
  const selectedSiteOption = useSelector(
    (state) => state.truInk.selectedSiteOption,
  );

  const scrollRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleScroll = (direction) => {
    if (!scrollRef.current) return;

    scrollRef.current.scrollBy({
      left: direction === "left" ? -150 : 150,
      behavior: "smooth",
    });
  };

  return (
    <div
      ref={scrollRef}
      style={{
        padding: isMobile ? "1% 32px" : "1% 3%",
        display: "flex",
        flexDirection: "row",
        gap: "2vw",
        width: "100%",
        justifyContent: isMobile ? "flex-start" : "space-between",
        alignItems: "center",
        overflowX: isMobile ? "auto" : "visible",
        flexWrap: "nowrap",
        scrollBehavior: "smooth",
        position: "relative",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      {isMobile && (
        <IconButton
          onClick={() => handleScroll("left")}
          size="small"
          style={{
            position: "fixed",
            left: 0,
            zIndex: 2,
          }}
        >
          <ChevronLeft />
        </IconButton>
      )}

      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          flex: isMobile ? "0 0 25%" : "unset",
          minWidth: isMobile ? "24%" : "auto",
        }}
        onClick={() => {
          dispatch(setTruInkSelectedSiteOption("SiteData"));
        }}
      >
        <h2
          style={{
            fontWeight: selectedSiteOption === "SiteData" ? "bold" : "initial",
            fontSize: "0.6rem",
            whiteSpace: "nowrap",
          }}
        >
          Site Data
        </h2>
        {selectedSiteOption === "SiteData" && (
          <p
            style={{
              position: "absolute",
              width: "5px",
              height: "5px",
              borderRadius: "50%",
              backgroundColor: "black",
              bottom: "-55%",
            }}
          ></p>
        )}
      </div>
      <Divider orientation="vertical" flexItem />
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          flex: isMobile ? "0 0 25%" : "unset",
          minWidth: isMobile ? "24%" : "auto",
        }}
        onClick={() => {
          dispatch(setTruInkSelectedSiteOption("Collections"));
        }}
      >
        <h2
          style={{
            fontWeight:
              selectedSiteOption === "Collections" ? "bold" : "initial",
            fontSize: "0.6rem",
          }}
        >
          Collections
        </h2>
        {selectedSiteOption === "Collections" && (
          <p
            style={{
              position: "absolute",
              width: "5px",
              height: "5px",
              borderRadius: "50%",
              backgroundColor: "black",
              bottom: "-55%",
            }}
          ></p>
        )}
      </div>

      <Divider orientation="vertical" flexItem />
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          flex: isMobile ? "0 0 25%" : "unset",
          minWidth: isMobile ? "24%" : "auto",
        }}
        onClick={() => {
          dispatch(setTruInkSelectedSiteOption("SiteTemplates"));
        }}
      >
        <h2
          style={{
            fontWeight:
              selectedSiteOption === "SiteTemplates" ? "bold" : "initial",
            fontSize: "0.6rem",
            whiteSpace: "nowrap",
          }}
        >
          Site Templates
        </h2>
        {selectedSiteOption === "SiteTemplates" && (
          <p
            style={{
              position: "absolute",
              width: "5px",
              height: "5px",
              borderRadius: "50%",
              backgroundColor: "black",
              bottom: "-55%",
            }}
          ></p>
        )}
      </div>
      <Divider orientation="vertical" flexItem />
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          flex: isMobile ? "0 0 25%" : "unset",
          minWidth: isMobile ? "24%" : "auto",
        }}
        onClick={() => {
          dispatch(setTruInkSelectedSiteOption("Gateways"));
        }}
      >
        <h2
          style={{
            fontWeight: selectedSiteOption === "Gateways" ? "bold" : "initial",
            fontSize: "0.6rem",
            whiteSpace: "nowrap",
          }}
        >
          Gateways
        </h2>
        {selectedSiteOption === "Gateways" && (
          <p
            style={{
              position: "absolute",
              width: "5px",
              height: "5px",
              borderRadius: "50%",
              backgroundColor: "black",
              bottom: "-55%",
            }}
          ></p>
        )}
      </div>
      <Divider orientation="vertical" flexItem />
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          flex: isMobile ? "0 0 25%" : "unset",
          minWidth: isMobile ? "24%" : "auto",
        }}
        onClick={() => {
          dispatch(setTruInkSelectedSiteOption("Digital Tags"));
        }}
      >
        <h2
          style={{
            fontWeight:
              selectedSiteOption === "Digital Tags" ? "bold" : "initial",
            fontSize: "0.6rem",
            whiteSpace: "nowrap",
          }}
        >
          Digital Tags
        </h2>
        {selectedSiteOption === "Digital Tags" && (
          <p
            style={{
              position: "absolute",
              width: "5px",
              height: "5px",
              borderRadius: "50%",
              backgroundColor: "black",
              bottom: "-55%",
            }}
          ></p>
        )}
      </div>
      <Divider orientation="vertical" flexItem />
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          flex: isMobile ? "0 0 25%" : "unset",
          minWidth: isMobile ? "24%" : "auto",
        }}
        onClick={() => {
          dispatch(setTruInkSelectedSiteOption("StoreSettings"));
        }}
      >
        <h2
          style={{
            fontWeight:
              selectedSiteOption === "StoreSettings" ? "bold" : "initial",
            fontSize: "0.6rem",
            whiteSpace: "nowrap",
          }}
        >
          Store Settings
        </h2>
        {selectedSiteOption === "StoreSettings" && (
          <p
            style={{
              position: "absolute",
              width: "5px",
              height: "5px",
              borderRadius: "50%",
              backgroundColor: "black",
              bottom: "-55%",
            }}
          ></p>
        )}
      </div>

      <Divider orientation="vertical" flexItem />
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          flex: isMobile ? "0 0 25%" : "unset",
          minWidth: isMobile ? "24%" : "auto",
        }}
        onClick={() => {
          dispatch(setTruInkSelectedSiteOption("Plugins"));
        }}
      >
        <h2
          style={{
            fontWeight: selectedSiteOption === "Plugins" ? "bold" : "initial",
            fontSize: "0.6rem",
            whiteSpace: "nowrap",
          }}
        >
          Plugins
        </h2>
        {selectedSiteOption === "Plugins" && (
          <p
            style={{
              position: "absolute",
              width: "5px",
              height: "5px",
              borderRadius: "50%",
              backgroundColor: "black",
              bottom: "-55%",
            }}
          ></p>
        )}
      </div>
      <Divider orientation="vertical" flexItem />
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          flex: isMobile ? "0 0 25%" : "unset",
          minWidth: isMobile ? "24%" : "auto",
        }}
        onClick={() => {
          dispatch(setTruInkSelectedSiteOption("Reports"));
        }}
      >
        <h2
          style={{
            fontWeight: selectedSiteOption === "Reports" ? "bold" : "initial",
            fontSize: "0.6rem",
            whiteSpace: "nowrap",
          }}
        >
          Reports
        </h2>
        {selectedSiteOption === "Reports" && (
          <p
            style={{
              position: "absolute",
              width: "5px",
              height: "5px",
              borderRadius: "50%",
              backgroundColor: "black",
              bottom: "-55%",
            }}
          ></p>
        )}
      </div>
      {isMobile && (
        <IconButton
          onClick={() => handleScroll("right")}
          size="small"
          style={{
            position: "fixed",
            right: 0,
            zIndex: 2,
          }}
        >
          <ChevronRight />
        </IconButton>
      )}
    </div>
  );
}

export default TruinkSiteOptions;
